// ExchangeSelector.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const ALLOWED_INDEXES = {
  'SP500': 'AAPL, MSFT, GOOGL, AMZN, TSLA, JPM, JNJ, V, PG, NVDA',
  'TSX': 'RY.TO, TD.TO, BNS.TO, ENB.TO, BMO.TO, CNR.TO, TRP.TO, SU.TO, BCE.TO, CNQ.TO',
  'CRYPTO': 'BTC-USD, ETH-USD, BNB-USD, ADA-USD, XRP-USD, SOL-USD, DOT-USD, DOGE-USD, AVAX-USD, MATIC-USD'
};

const ExchangeSelector = ({ currentIndex, onIndexChange }) => (
  <div className={styles.exchangeColumn}>
    <div className={styles.exchangeSelectorGroup}>
      <span className={styles.exchangeLabel}>Select Exchange:</span>
      <div className={styles.radioGroup}>
        {Object.keys(ALLOWED_INDEXES).map((indexName) => (
          <label key={indexName} className={styles.radioItem}>
            <input
              type="radio"
              name="index_name"
              value={indexName}
              checked={currentIndex === indexName}
              onChange={() => onIndexChange(indexName)}
            />
            <span className={styles.radioLabelText}>{indexName}</span>
          </label>
        ))}
      </div>
    </div>
  </div>
);

ExchangeSelector.propTypes = {
  currentIndex: PropTypes.string,
  onIndexChange: PropTypes.func.isRequired,
};

export default ExchangeSelector;